(() => {
  'use strict';
  const initialized = new WeakSet();
  function start(scope = document) {
    scope.querySelectorAll('[data-mg-blended]').forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      const form = root.querySelector('.mg-t8-form');
      if (!form) return;
      const quantity = form.querySelector('[name="quantity"]');
      const variantSelect = form.querySelector('[name="id"]');
      const product = JSON.parse(document.getElementById(`ProductJson-${root.dataset.sectionId}`).textContent);
      const copyNode = root.closest('.shopify-section')?.querySelector('[data-mg-blended-copy]');
      const copy = JSON.parse(copyNode?.textContent || '{}');
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:root.dataset.currency || 'AUD'}).format(cents / 100);
      const setText = (node, value) => {if (node && node.textContent !== value) node.textContent=value;};
      const cards = [...form.querySelectorAll('[data-simple-addon-card]')];
      const status = form.querySelector('[data-blended-status]');
      const note = form.querySelector('[data-note-input]');
      let submitting = false;
      function message(text) { status.textContent = text; status.hidden = !text; }
      function normalizeInitials() {
        form.querySelectorAll('.mg-t8-personalisation input[name^="properties["],.mg-t8-personalisation textarea[name^="properties["]').forEach(field => {
          if (field.disabled || ['hidden','file','checkbox','radio'].includes(field.type) || /colo[u]?r|foil/i.test(field.name)) return;
          const upper = field.value.toUpperCase();
          if (upper === field.value) return;
          const start = field.selectionStart, end = field.selectionEnd;
          field.value = upper;
          if (start !== null && end !== null && field.setSelectionRange) field.setSelectionRange(start, end);
        });
      }
      function personalization() {
        const text = [...form.querySelectorAll('.mg-t8-personalisation input[name^="properties["],.mg-t8-personalisation textarea[name^="properties["]')]
          .filter(el => !el.disabled && !['hidden','file','checkbox','radio'].includes(el.type) && !/colo[u]?r|foil/i.test(el.name))
          .map(el => el.value.trim()).filter(Boolean).join(' / ');
        const colourField = [...form.querySelectorAll('.mg-t8-personalisation [name^="properties["]')]
          .find(el => /colo[u]?r|foil/i.test(el.name) && !el.disabled);
        const colour = colourField ? foilDisplayName(colourField.value, colourField) : '';
        return {text, colour, summary:[text,colour].filter(Boolean).join(' · ')};
      }
      function foilDisplayName(value, field) {
        const raw=String(value || '').trim();
        if(!/^#[\da-f]{3,8}$/i.test(raw))return raw;
        const selected=field?.closest('.pplr-wrapper')?.querySelector('.pplr-swatch-element.selected');
        const name=selected?.dataset.name?.trim();
        if(name && !/^#/.test(name))return name;
        const foils={
          '#d1af3f':'Gold Foil','#f4d10e':'Gold Foil','#b6813c':'Gold Foil',
          '#d3d3d3':'Silver Foil','#b9bcc4':'Silver Foil',
          '#4d2020':'Imprint - No Foil','#c5beb2':'Imprint - No Foil',
          '#00b300':'Green Foil','#286149':'Green Foil',
          '#e50000':'Red Foil','#a33a3a':'Red Foil',
          '#2232b5':'Blue Foil','#315a86':'Blue Foil',
          '#000000':'Black Foil','#191c3b':'Black Foil',
          '#c89098':'Rose Gold Foil','#b76e79':'Rose Gold Foil',
          '#ffffff':'White Foil','#f5f3ee':'White Foil'
        };
        return foils[raw.toLowerCase()] || raw;
      }
      function checkoutProperties(source) {
        const result={};
        const passport=Object.keys(source).some(key=>/^personalisation text for passport holder\b/i.test(key));
        const fields=[...form.querySelectorAll('.mg-t8-personalisation [name^="properties["]')];
        Object.entries(source).forEach(([key,value])=>{
          if(key.startsWith('_')){result[key]=value;return;}
          let label=key;
          if(/^personalisation text for passport holder\b/i.test(key))label='Passport holder — Personalisation';
          else if(/^personalisation text for luggage tag\b/i.test(key))label='Luggage tag — Personalisation';
          else if(/^(personalisation text\s*-|initials$|personalisation$)/i.test(key))label='Personalisation';
          else if(/colo[u]?r|foil/i.test(key) && /personali[sz]ation|foil/i.test(key)){
            label=passport ? (/2$|luggage tag/i.test(key) ? 'Luggage tag — Personalisation Colour' : 'Passport holder — Personalisation Colour') : 'Personalisation Colour';
          }
          if(label!==key){
            const field=fields.find(input=>input.name===`properties[${key}]`);
            result[label]=/Colour$/.test(label) ? foilDisplayName(value,field) : value;
          }else result[key]=value;
        });
        return result;
      }
      function bundleMetadata(qty) {
        if (root.dataset.profile !== 'gloves' || root.dataset.discounts !== 'true' || qty < 2) return null;
        for (const block of document.querySelectorAll('section-store--bundle-block[data-block-bundles]')) {
          if (String(block.dataset.productId) !== String(product.id)) continue;
          try {
            const bundles = JSON.parse(block.dataset.blockBundles);
            for (const bundle of bundles) {
              const options = (bundle.options || []).filter(option => option.discount_strategy === 'volume_discount' && option.volume_discount?.discount_type === 'percentage_off' && Number(option.volume_discount.minimum_quantity) <= qty).sort((a,b) => Number(b.volume_discount.minimum_quantity) - Number(a.volume_discount.minimum_quantity));
              const option = options[0];
              if (bundle.short_id && option?.short_id) return {bundle_id:bundle.short_id,bundle_option_id:option.short_id};
            }
          } catch (_) {}
        }
        return null;
      }
      function selected(card, active) {
        card.dataset.addonSelected = String(active);
        card.classList.toggle('is-selected',active);
        const toggle = card.querySelector('[data-simple-addon-toggle]');
        toggle?.setAttribute('aria-pressed',String(active));
        const label = card.querySelector('[data-addon-toggle-label]');
        if (label) label.textContent = active ? card.dataset.addonIncludedLabel : card.dataset.addonButtonLabel;
      }
      function choice(card, button) {
        if (button.dataset.choiceAvailable === 'false') return;
        card.querySelectorAll('[data-simple-addon-choice]').forEach(el => {
          el.classList.toggle('is-active',el === button);
          el.setAttribute('aria-pressed',String(el === button));
        });
        ['VariantId','LivePriceCents','DisplayPriceCents','RegularPriceCents','ProductUrl'].forEach(key => card.dataset[`addon${key}`] = button.dataset[`choice${key}`] || '');
        card.dataset.addonColour = button.dataset.choiceLabel;
        const image = card.querySelector('.mg-simple-addon__image');
        if (image && button.dataset.choiceImageUrl) {image.src = button.dataset.choiceImageUrl;image.removeAttribute('srcset');}
        const link = card.querySelector('[data-addon-link]');
        if (link) link.href = button.dataset.choiceProductUrl;
        const label = card.querySelector('[data-addon-colour-label]');
        if (label) {label.textContent=button.dataset.choiceLabel;label.hidden=false;}
        const price = Number(button.dataset.choiceDisplayPriceCents);
        const regular = Number(button.dataset.choiceRegularPriceCents);
        const priceNode = card.querySelector('[data-addon-price]');
        if (priceNode) priceNode.textContent = money(price);
        const compare = card.querySelector('[data-addon-compare]');
        if (compare) {compare.textContent=money(regular);compare.classList.toggle('is-hidden',regular<=price);}
        const saving = card.querySelector('[data-addon-saving]');
        if (saving) {saving.textContent=`${copy.save} ${money(regular-price)}`;saving.classList.toggle('is-hidden',regular<=price);}
        card.querySelector('[data-simple-addon-toggle]').disabled=false;
        card.querySelector('[data-addon-status]').textContent='';
      }
      function update() {
        normalizeInitials();
        const variant = product.variants.find(v => String(v.id) === variantSelect.value);
        if (!variant) return;
        const qty = Number(quantity.value);
        const discount=root.dataset.discounts==='true' ? Number(qty===2 ? root.dataset.discountTwo : qty>=3 ? root.dataset.discountThree : 0) : 0;
        const unit=Math.round(variant.price*(1-discount/100));
        const active = cards.filter(card => card.dataset.addonSelected === 'true' && card.dataset.addonVariantId);
        const addonTotal = active.reduce((sum, card) => {
          const display = card.dataset.addonDisplayPriceCents;
          const price = Number(display === '' || display == null ? card.dataset.addonLivePriceCents : display);
          return sum + (Number.isFinite(price) ? Math.max(0, price) : 0);
        }, 0);
        const total = unit * qty + addonTotal;
        setText(form.querySelector('[data-mg-quantity-total]'), money(total));
        const stickyPrice = root.querySelector('#js-sticky-price');
        setText(stickyPrice, money(total));
        if (stickyPrice) stickyPrice.setAttribute('aria-label', `${copy.total || 'Total'} ${money(total)}`);
        const included = form.querySelector('[data-mg-addon-total]');
        if (included) {
          included.hidden = !active.length;
          const label = active.length === 1 ? copy.addon_included : copy.addons_included;
          setText(included, (label || 'Includes {count} add-ons · {amount}').replace('{count}', String(active.length)).replace('{amount}', money(addonTotal)));
        }
        const savings=form.querySelector('[data-mg-quantity-saving]');
        if(savings){savings.hidden=!discount;setText(savings,discount ? `Save ${money((variant.price-unit)*qty)}` : '');}
        form.querySelectorAll('[data-quantity-choice]').forEach(button => {
          const choice = Number(button.dataset.quantityChoice);
          button.setAttribute('aria-pressed', String(choice === 3 ? qty >= 3 : qty === choice));
        });
        const values=personalization();
        const same=form.querySelector('[data-mg-same-details]');if(same)same.hidden=qty<2;
        const text=form.querySelector('[data-quantity-personalisation-text]');
        const colour=form.querySelector('[data-quantity-personalisation-colour]');
        setText(text,values.text || copy.pending);
        setText(colour,values.colour || copy.pending);
        cards.forEach(card => {
          card.dataset.addonPersonalisation=values.summary;
          const label=card.querySelector('[data-addon-personalisation-value]');
          setText(label,values.text ? values.summary : copy.pending);
        });
        const count=form.querySelector('[data-note-count]');
        if(count)setText(count,String(note.value.length));
      }
      async function submit() {
        if (submitting) return;
        normalizeInitials();
        if (!form.reportValidity()) return;
        const variant=product.variants.find(v=>String(v.id)===variantSelect.value);
        if (!variant?.available || !Number.isInteger(Number(quantity.value)) || Number(quantity.value)<1) return;
        const fields=form.querySelectorAll('.mg-t8-personalisation [name^="properties["]:not([type="hidden"])');
        if ((root.dataset.personalisationRequired==='1' || root.dataset.profile==='gloves') && !fields.length) {message(copy.pending);return;}
        const data=new FormData(form);
        const rawProperties={};
        for (const [name,value] of data) {
          const match=name.match(/^properties\[(.+)\]$/);
          if (!match) continue;
          if (value instanceof File) {if(value.size){message(copy.upload);return;}continue;}
          if (String(value).trim()) rawProperties[match[1]]=String(value).trim();
        }
        const properties=checkoutProperties(rawProperties);
        const active=cards.filter(card=>card.dataset.addonSelected==='true');
        const group=`MG8-${Date.now()}-${crypto.randomUUID()}`;
        const personalisation=personalization();
        const extras=active.map(card=>({id:Number(card.dataset.addonVariantId),quantity:1,properties:{'_Gift set ID':group,'_Added as':'Product add-on','_MG Configuration':`${card.dataset.addonTitle} · ${card.dataset.addonColour}`,'_Selected colour':card.dataset.addonColour,'Personalisation':personalisation.text,'Personalisation Colour':personalisation.colour}}));
        if(extras.some(item=>!item.id)){message(copy.choose_colour);return;}
        if(active.length){properties['_Gift set ID']=group;properties['_Gift set includes']=extras.map(item=>item.properties['_MG Configuration']).join(', ');}
        if(note && !note.disabled && note.value.trim())properties['_MG Gift note']=note.value.trim();
        delete properties.__section_store_bundle;
        const bundle = bundleMetadata(Number(quantity.value));
        if (root.dataset.profile === 'gloves' && root.dataset.discounts === 'true' && Number(quantity.value) >= 2 && !bundle) {message(copy.failed);return;}
        if (bundle) properties.__section_store_bundle = JSON.stringify(bundle);
        const main={id:Number(variantSelect.value),quantity:Number(quantity.value),properties};
        if(data.get('selling_plan'))main.selling_plan=Number(data.get('selling_plan'));
        const buttons=[...root.querySelectorAll('.mg-t8-atc,#js-sticky-btn')];
        submitting=true;buttons.forEach(button=>button.disabled=true);form.setAttribute('aria-busy','true');message('');
        const route=window.Shopify?.routes?.root || '/';
        let sent=false;
        try {
          sent=true;
          const response=await fetch(`${route}cart/add.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json','section-store-bundle-intercepted':'1'},body:JSON.stringify({items:[main,...extras]})});
          const payload=await response.json();
          if(!response.ok){sent=false;throw new Error(payload.description || payload.message || copy.failed);}
          message('');
          if(window.MGCart) await window.MGCart.open(form.querySelector('.mg-t8-atc'));
          else document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{source:'mg-product',result:payload}}));
        } catch(error) {
          message(sent ? copy.uncertain : error.message || copy.failed);
          if(sent){const link=document.createElement('a');link.href=`${route}cart`;link.textContent=' View cart';status.append(link);}
        } finally {
          submitting=false;buttons.forEach(button=>button.disabled=!variant.available);form.removeAttribute('aria-busy');
        }
      }
      root.addEventListener('click',event=> {
        const button=event.target.closest('button');
        if(!button)return;
        if(button.matches('.mg-t8-atc,#js-sticky-btn')){event.preventDefault();event.stopImmediatePropagation();submit();return;}
        if(button.matches('[data-quantity-choice]')){
          quantity.value=button.dataset.quantityChoice;quantity.dispatchEvent(new Event('change',{bubbles:true}));
        }
        if(button.matches('[data-gift-section-toggle]')){
          const opened=button.getAttribute('aria-expanded')!=='true';
          button.setAttribute('aria-expanded',String(opened));
          button.closest('[data-gift-section]').classList.toggle('is-open',opened);
          document.getElementById(button.getAttribute('aria-controls')).hidden=!opened;
          button.querySelector('[data-gift-toggle-copy]').textContent=opened ? button.dataset.collapseLabel : button.dataset.expandLabel;
        }
        if(button.matches('[data-simple-addon-choice]'))choice(button.closest('[data-simple-addon-card]'),button);
        if(button.matches('[data-simple-addon-toggle]')){
          const card=button.closest('[data-simple-addon-card]');
          if(!card.dataset.addonVariantId){card.querySelector('[data-addon-status]').textContent=copy.choose_colour;card.querySelector('[data-simple-addon-choice]')?.focus();}
          else selected(card,card.dataset.addonSelected!=='true');
        }
        if(button.matches('[data-note-toggle]')){
          const on=button.getAttribute('aria-pressed')!=='true';button.setAttribute('aria-pressed',String(on));button.classList.toggle('is-on',on);note.disabled=!on;form.querySelector('[data-note-fields]').hidden=!on;if(on)note.focus();
        }
        update();
        setTimeout(update,0);
      },true);
      form.addEventListener('submit',event=>{event.preventDefault();event.stopImmediatePropagation();submit();},true);
      root.addEventListener('change',()=>setTimeout(update,0));
      root.addEventListener('input', event => { if (!event.isComposing) update(); }, true);
      cards.forEach(card=>selected(card,false));
      update();
      setTimeout(update,1500);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>start());else start();
  document.addEventListener('shopify:section:load',event=>start(event.target));
})();
